import * as React from "react";
import {
  Card,
  message,
  Form,
  Alert,
  Input,
  Button,
  List,
  Tag,
  Select,
  Popconfirm
} from "antd";

import { Fragment } from "react";

import { Redirect } from "react-router";
import { FormComponentProps } from "antd/lib/form";
import { NavLink } from "react-router-dom";
import Meta from "antd/lib/card/Meta";
import RolesQuery from "src/queries/RolesQuery";
import {
  GetMailingListQuery_mailingList_members_roles,
  GetMailingListQuery_mailingList_members_users
} from "src/__generated__/types";
import UsersQuery from "src/queries/UsersQuery";
import DeleteMailingList from "src/mutations/DeleteMailingList";
const FormItem = Form.Item;

export interface MailingListMember {
  id: string;
  email: string;
  name: string;
  subscribed: boolean;
}

export interface MailingList {
  id: string;
  description: string;
  address: string;
  members: MailingListMember[];
  members_roles: GetMailingListQuery_mailingList_members_roles[];
  members_users: GetMailingListQuery_mailingList_members_users[];
}

export interface MailingListSubmit {
  id: string;
  description: string;
  address: string;
  members_roles: string[];
  members_users: string[];
}

export interface Props extends FormComponentProps {
  mailinglist: MailingList | null;
  loading?: boolean;
  error?: string;
  add?: boolean;
  onSubmit?: (data: MailingListSubmit) => void;
}

export interface State {
  deleted: boolean;
}

const cardStyle = { marginTop: 30, maxWidth: 750 };

export class MailingListDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { deleted: false };
  }

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    this.props.form.validateFields((err, values: MailingListSubmit) => {
      console.log(values);
      if (!err && this.props.onSubmit) {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    if (!this.props.add) {
      if (!this.props.loading && this.state.deleted) {
        return <Redirect to="/mailinglists" />;
      }
      if (!this.props.loading && this.props.mailinglist == null) {
        message.error("List not found");
        return <Redirect to="/" />;
      }
    }
    const { getFieldDecorator } = this.props.form;
    return (
      <Fragment>
        <Card
          loading={this.props.loading}
          title={
            this.props.loading
              ? "Loading..."
              : this.props.mailinglist
              ? this.props.mailinglist.description
              : "New Mailinglist"
          }
          extra={<></>}
          style={cardStyle}
        >
          <>
            <Form onSubmit={this.handleSubmit}>
              {this.props.error && (
                <Alert
                  message={this.props.error}
                  type="error"
                  showIcon={true}
                />
              )}
              <FormItem label="List Adress">
                {getFieldDecorator("address", {
                  initialValue:
                    this.props.mailinglist && this.props.mailinglist.address,
                  rules: [
                    { required: true, message: "Please input a address!" }
                  ]
                })(<Input readOnly={!this.props.add} />)}
              </FormItem>
              <FormItem label="Description">
                {getFieldDecorator("description", {
                  initialValue:
                    this.props.mailinglist &&
                    this.props.mailinglist.description,
                  rules: [
                    { required: true, message: "Please input a description!" }
                  ]
                })(<Input />)}
              </FormItem>
              <FormItem label="Roles">
                <RolesQuery>
                  {({ loading, error, data }) => {
                    return getFieldDecorator("members_roles", {
                      initialValue:
                        (this.props.mailinglist &&
                          this.props.mailinglist.members_roles &&
                          this.props.mailinglist.members_roles.map(
                            r => r.name
                          )) ||
                        []
                    })(
                      <Select
                        loading={loading}
                        mode="multiple"
                        style={{ width: "100%" }}
                      >
                        {data &&
                          data.roles &&
                          data.roles.map(
                            s =>
                              s && (
                                <Select.Option key={s.name}>
                                  {s.name}
                                </Select.Option>
                              )
                          )}
                      </Select>
                    );
                  }}
                </RolesQuery>
              </FormItem>
              <FormItem label="Users">
                <UsersQuery>
                  {({ loading, error, data }) => {
                    return getFieldDecorator("members_users", {
                      initialValue:
                        (this.props.mailinglist &&
                          this.props.mailinglist.members_users &&
                          this.props.mailinglist.members_users.map(
                            u => u.id
                          )) ||
                        []
                    })(
                      <Select
                        loading={loading}
                        mode="multiple"
                        style={{ width: "100%" }}
                      >
                        {data &&
                          data.users &&
                          data.users.map(
                            s =>
                              s && (
                                <Select.Option value={s.id} key={s.id}>
                                  {s.name}
                                </Select.Option>
                              )
                          )}
                      </Select>
                    );
                  }}
                </UsersQuery>
              </FormItem>
              <FormItem>
                <Button
                  loading={this.props.loading}
                  htmlType="submit"
                  type="danger"
                >
                  {this.props.add ? "Create" : "Update"}
                </Button>
              </FormItem>
            </Form>
          </>
        </Card>
        {this.props.mailinglist && (
          <Card
            loading={this.props.loading}
            title={"Users in List"}
            style={cardStyle}
            bodyStyle={{ padding: 0 }}
          >
            {this.props.mailinglist.members && (
              <List
                grid={{ gutter: 0, xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
                size="small"
                dataSource={this.props.mailinglist.members}
                renderItem={(user: MailingListMember) => (
                  <List.Item>
                    <Card.Grid style={{ width: "100%" }}>
                      <Meta
                        title={
                          <NavLink to={`/users/${user.id}`}>
                            {user.name}
                          </NavLink>
                        }
                        description={
                          user.subscribed ? (
                            <Tag color="green">Subscribed</Tag>
                          ) : (
                            <Tag color="red">Un-subscribed</Tag>
                          )
                        }
                      />
                    </Card.Grid>
                  </List.Item>
                )}
              />
            )}
          </Card>
        )}
        {!this.props.add && (
          <Card
            className="danger"
            loading={this.props.loading}
            title="Admin"
            style={cardStyle}
          >
            {this.props.mailinglist && (
              <>
                <DeleteMailingList
                  onCompleted={e =>
                    this.setState({ deleted: true }, () =>
                      message.success(
                        `${e.deleteMailingList &&
                          e.deleteMailingList.description} deleted`
                      )
                    )
                  }
                  onError={e =>
                    message.error(
                      e.graphQLErrors[0]
                        ? e.graphQLErrors[0].message
                        : "Unknown error"
                    )
                  }
                >
                  {delUser => (
                    <Popconfirm
                      title="Delete the mailing list? This action is permanent!"
                      onConfirm={() =>
                        this.props.mailinglist &&
                        delUser({
                          variables: { id: this.props.mailinglist.id }
                        })
                      }
                      onCancel={() => console.log("cancel")}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="danger">Delete list</Button>
                    </Popconfirm>
                  )}
                </DeleteMailingList>
              </>
            )}
          </Card>
        )}
      </Fragment>
    );
  }
}

export default Form.create<Props>()(MailingListDetails);



// WEBPACK FOOTER //
// ./src/components/MailingListDetails/MailingListDetails.tsx